import React, { useEffect } from 'react';
import { nanoid } from '@reduxjs/toolkit';

const DynamicCompContain = (comps, config) => {
    console.log(Object.keys(config))
    return (
        <>
        {config.map(({ componentName, props }) => {
            const Component = comps[componentName];
            return <Component key={nanoid()} {...props} />;
        })}
        </>
    )
}

export default DynamicCompContain;
